/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type TripDetailsResponse = {
  __typename: "TripDetailsResponse",
  id: string,
  tripName: string,
  description?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  createdBy: string,
  creatorName?: string | null,
  storageUsed?: number | null,
  members?:  Array<MemberResponse | null > | null,
  photos?:  Array<PhotoDetailResponse | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  userRole?: string | null,
};

export type MemberResponse = {
  __typename: "MemberResponse",
  id: string,
  userId: string,
  role: string,
  userName?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type PhotoDetailResponse = {
  __typename: "PhotoDetailResponse",
  id: string,
  fileName: string,
  s3Key: string,
  uploadedBy: string,
  uploaderName?: string | null,
  status: string,
  fileSize: number,
  contentType?: string | null,
  thumbnailS3Key?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelTripConnection = {
  __typename: "ModelTripConnection",
  items:  Array<Trip | null >,
  nextToken?: string | null,
};

export type Trip = {
  __typename: "Trip",
  id: string,
  tripName: string,
  description?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  createdBy: string,
  storageUsed?: number | null,
  members?: ModelTripMemberConnection | null,
  photos?: ModelPhotoConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelTripMemberConnection = {
  __typename: "ModelTripMemberConnection",
  items:  Array<TripMember | null >,
  nextToken?: string | null,
};

export type TripMember = {
  __typename: "TripMember",
  id: string,
  tripId: string,
  userId: string,
  role: TripRole,
  trip?: Trip | null,
  user?: User | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export enum TripRole {
  PARTICIPANT = "PARTICIPANT",
  VIEWER = "VIEWER",
}


export type User = {
  __typename: "User",
  id: string,
  name: string,
  email?: string | null,
  phoneNumber?: string | null,
  storageTier?: StorageTier | null,
  storageUsed?: number | null,
  storageLimit?: number | null,
  friends?: ModelFriendConnection | null,
  trips?: ModelTripMemberConnection | null,
  stripeCustomerId?: string | null,
  subscriptionId?: string | null,
  subscriptionStatus?: string | null,
  subscriptionPeriodEnd?: number | null,
  appleSubscriptionId?: string | null,
  googleSubscriptionId?: string | null,
  appleReceiptData?: string | null,
  googlePurchaseToken?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum StorageTier {
  VIEWER = "VIEWER",
  FREE = "FREE",
  BASIC = "BASIC",
  PREMIUM = "PREMIUM",
  PROFESSIONAL = "PROFESSIONAL",
  GOD = "GOD",
}


export type ModelFriendConnection = {
  __typename: "ModelFriendConnection",
  items:  Array<Friend | null >,
  nextToken?: string | null,
};

export type Friend = {
  __typename: "Friend",
  id: string,
  userId: string,
  friendId: string,
  friendName: string,
  phoneNumber?: string | null,
  invited?: boolean | null,
  user?: User | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type ModelPhotoConnection = {
  __typename: "ModelPhotoConnection",
  items:  Array<Photo | null >,
  nextToken?: string | null,
};

export type Photo = {
  __typename: "Photo",
  id: string,
  tripId: string,
  fileName: string,
  s3Key: string,
  uploadedBy: string,
  status: PhotoStatus,
  fileSize: number,
  trip?: Trip | null,
  contentType?: string | null,
  thumbnailS3Key?: string | null,
  thumbnailWidth?: number | null,
  thumbnailHeight?: number | null,
  thumbnailSize?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
};

export enum PhotoStatus {
  PENDING = "PENDING",
  UPLOADED = "UPLOADED",
}


export type ModelTripFilterInput = {
  id?: ModelIDInput | null,
  tripName?: ModelStringInput | null,
  description?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  createdBy?: ModelIDInput | null,
  storageUsed?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTripFilterInput | null > | null,
  or?: Array< ModelTripFilterInput | null > | null,
  not?: ModelTripFilterInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelTripMemberFilterInput = {
  id?: ModelIDInput | null,
  tripId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  role?: ModelTripRoleInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTripMemberFilterInput | null > | null,
  or?: Array< ModelTripMemberFilterInput | null > | null,
  not?: ModelTripMemberFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelTripRoleInput = {
  eq?: TripRole | null,
  ne?: TripRole | null,
};

export type TripMembershipResponse = {
  __typename: "TripMembershipResponse",
  trip: TripDetailsResponse,
  membership?: MemberResponse | null,
  invitationProcessed: boolean,
  message?: string | null,
};

export type UpdatePhotoInput = {
  id: string,
  tripId?: string | null,
  fileName?: string | null,
  s3Key?: string | null,
  uploadedBy?: string | null,
  status?: PhotoStatus | null,
  fileSize?: number | null,
  contentType?: string | null,
  thumbnailS3Key?: string | null,
  thumbnailWidth?: number | null,
  thumbnailHeight?: number | null,
  thumbnailSize?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
};

export type ModelPhotoConditionInput = {
  tripId?: ModelIDInput | null,
  fileName?: ModelStringInput | null,
  s3Key?: ModelStringInput | null,
  uploadedBy?: ModelIDInput | null,
  status?: ModelPhotoStatusInput | null,
  fileSize?: ModelFloatInput | null,
  contentType?: ModelStringInput | null,
  thumbnailS3Key?: ModelStringInput | null,
  thumbnailWidth?: ModelIntInput | null,
  thumbnailHeight?: ModelIntInput | null,
  thumbnailSize?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelPhotoConditionInput | null > | null,
  or?: Array< ModelPhotoConditionInput | null > | null,
  not?: ModelPhotoConditionInput | null,
};

export type ModelPhotoStatusInput = {
  eq?: PhotoStatus | null,
  ne?: PhotoStatus | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type CreateUserInput = {
  id?: string | null,
  name: string,
  email?: string | null,
  phoneNumber?: string | null,
  storageTier?: StorageTier | null,
  storageUsed?: number | null,
  storageLimit?: number | null,
  stripeCustomerId?: string | null,
  subscriptionId?: string | null,
  subscriptionStatus?: string | null,
  subscriptionPeriodEnd?: number | null,
  appleSubscriptionId?: string | null,
  googleSubscriptionId?: string | null,
  appleReceiptData?: string | null,
  googlePurchaseToken?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelUserConditionInput = {
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  storageTier?: ModelStorageTierInput | null,
  storageUsed?: ModelFloatInput | null,
  storageLimit?: ModelFloatInput | null,
  stripeCustomerId?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  subscriptionStatus?: ModelStringInput | null,
  subscriptionPeriodEnd?: ModelIntInput | null,
  appleSubscriptionId?: ModelStringInput | null,
  googleSubscriptionId?: ModelStringInput | null,
  appleReceiptData?: ModelStringInput | null,
  googlePurchaseToken?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  id?: ModelStringInput | null,
};

export type ModelStorageTierInput = {
  eq?: StorageTier | null,
  ne?: StorageTier | null,
};

export type UpdateUserInput = {
  id: string,
  name?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  storageTier?: StorageTier | null,
  storageUsed?: number | null,
  storageLimit?: number | null,
  stripeCustomerId?: string | null,
  subscriptionId?: string | null,
  subscriptionStatus?: string | null,
  subscriptionPeriodEnd?: number | null,
  appleSubscriptionId?: string | null,
  googleSubscriptionId?: string | null,
  appleReceiptData?: string | null,
  googlePurchaseToken?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateStorageTierConfigInput = {
  id?: string | null,
  tier: StorageTier,
  name: string,
  storageBytes: number,
  pricePerMonth: number,
  features: Array< string | null >,
  version: number,
  isDefault?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  stripePriceId?: string | null,
  stripeProductId?: string | null,
  appleProductId?: string | null,
  googleProductId?: string | null,
};

export type ModelStorageTierConfigConditionInput = {
  tier?: ModelStorageTierInput | null,
  name?: ModelStringInput | null,
  storageBytes?: ModelFloatInput | null,
  pricePerMonth?: ModelFloatInput | null,
  features?: ModelStringInput | null,
  version?: ModelFloatInput | null,
  isDefault?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  stripePriceId?: ModelStringInput | null,
  stripeProductId?: ModelStringInput | null,
  appleProductId?: ModelStringInput | null,
  googleProductId?: ModelStringInput | null,
  and?: Array< ModelStorageTierConfigConditionInput | null > | null,
  or?: Array< ModelStorageTierConfigConditionInput | null > | null,
  not?: ModelStorageTierConfigConditionInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type StorageTierConfig = {
  __typename: "StorageTierConfig",
  id: string,
  tier: StorageTier,
  name: string,
  storageBytes: number,
  pricePerMonth: number,
  features: Array< string | null >,
  version: number,
  isDefault?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  stripePriceId?: string | null,
  stripeProductId?: string | null,
  appleProductId?: string | null,
  googleProductId?: string | null,
};

export type UpdateStorageTierConfigInput = {
  id: string,
  tier?: StorageTier | null,
  name?: string | null,
  storageBytes?: number | null,
  pricePerMonth?: number | null,
  features?: Array< string | null > | null,
  version?: number | null,
  isDefault?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  stripePriceId?: string | null,
  stripeProductId?: string | null,
  appleProductId?: string | null,
  googleProductId?: string | null,
};

export type DeleteStorageTierConfigInput = {
  id: string,
};

export type CreateSubscriptionEventInput = {
  id?: string | null,
  userId: string,
  eventType: string,
  platform: string,
  subscriptionId?: string | null,
  productId?: string | null,
  previousTier?: StorageTier | null,
  newTier?: StorageTier | null,
  metadata?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelSubscriptionEventConditionInput = {
  userId?: ModelIDInput | null,
  eventType?: ModelStringInput | null,
  platform?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  productId?: ModelStringInput | null,
  previousTier?: ModelStorageTierInput | null,
  newTier?: ModelStorageTierInput | null,
  metadata?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSubscriptionEventConditionInput | null > | null,
  or?: Array< ModelSubscriptionEventConditionInput | null > | null,
  not?: ModelSubscriptionEventConditionInput | null,
};

export type SubscriptionEvent = {
  __typename: "SubscriptionEvent",
  id: string,
  userId: string,
  eventType: string,
  platform: string,
  subscriptionId?: string | null,
  productId?: string | null,
  previousTier?: StorageTier | null,
  newTier?: StorageTier | null,
  metadata?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSubscriptionEventInput = {
  id: string,
  userId?: string | null,
  eventType?: string | null,
  platform?: string | null,
  subscriptionId?: string | null,
  productId?: string | null,
  previousTier?: StorageTier | null,
  newTier?: StorageTier | null,
  metadata?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteSubscriptionEventInput = {
  id: string,
};

export type CreateFriendInput = {
  id?: string | null,
  userId: string,
  friendId: string,
  friendName: string,
  phoneNumber?: string | null,
  invited?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelFriendConditionInput = {
  userId?: ModelIDInput | null,
  friendId?: ModelIDInput | null,
  friendName?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  invited?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFriendConditionInput | null > | null,
  or?: Array< ModelFriendConditionInput | null > | null,
  not?: ModelFriendConditionInput | null,
  owner?: ModelStringInput | null,
};

export type UpdateFriendInput = {
  id: string,
  userId?: string | null,
  friendId?: string | null,
  friendName?: string | null,
  phoneNumber?: string | null,
  invited?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteFriendInput = {
  id: string,
};

export type CreateTripInput = {
  id?: string | null,
  tripName: string,
  description?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  createdBy: string,
  storageUsed?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelTripConditionInput = {
  tripName?: ModelStringInput | null,
  description?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  createdBy?: ModelIDInput | null,
  storageUsed?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTripConditionInput | null > | null,
  or?: Array< ModelTripConditionInput | null > | null,
  not?: ModelTripConditionInput | null,
};

export type UpdateTripInput = {
  id: string,
  tripName?: string | null,
  description?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  createdBy?: string | null,
  storageUsed?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteTripInput = {
  id: string,
};

export type CreateTripMemberInput = {
  id?: string | null,
  tripId: string,
  userId: string,
  role: TripRole,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelTripMemberConditionInput = {
  tripId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  role?: ModelTripRoleInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTripMemberConditionInput | null > | null,
  or?: Array< ModelTripMemberConditionInput | null > | null,
  not?: ModelTripMemberConditionInput | null,
  owner?: ModelStringInput | null,
};

export type UpdateTripMemberInput = {
  id: string,
  tripId?: string | null,
  userId?: string | null,
  role?: TripRole | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteTripMemberInput = {
  id: string,
};

export type CreatePhotoInput = {
  id?: string | null,
  tripId: string,
  fileName: string,
  s3Key: string,
  uploadedBy: string,
  status: PhotoStatus,
  fileSize: number,
  contentType?: string | null,
  thumbnailS3Key?: string | null,
  thumbnailWidth?: number | null,
  thumbnailHeight?: number | null,
  thumbnailSize?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
};

export type DeletePhotoInput = {
  id: string,
};

export type CreateTripInvitationInput = {
  id?: string | null,
  tripId: string,
  token: string,
  role: TripRole,
  createdBy: string,
  expiresAt: number,
  usedBy?: string | null,
  usedAt?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
};

export type ModelTripInvitationConditionInput = {
  tripId?: ModelIDInput | null,
  token?: ModelStringInput | null,
  role?: ModelTripRoleInput | null,
  createdBy?: ModelIDInput | null,
  expiresAt?: ModelIntInput | null,
  usedBy?: ModelIDInput | null,
  usedAt?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelTripInvitationConditionInput | null > | null,
  or?: Array< ModelTripInvitationConditionInput | null > | null,
  not?: ModelTripInvitationConditionInput | null,
};

export type TripInvitation = {
  __typename: "TripInvitation",
  id: string,
  tripId: string,
  token: string,
  role: TripRole,
  createdBy: string,
  expiresAt: number,
  usedBy?: string | null,
  usedAt?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
};

export type UpdateTripInvitationInput = {
  id: string,
  tripId?: string | null,
  token?: string | null,
  role?: TripRole | null,
  createdBy?: string | null,
  expiresAt?: number | null,
  usedBy?: string | null,
  usedAt?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
};

export type DeleteTripInvitationInput = {
  id: string,
};

export type TripMemberRemovalResult = {
  __typename: "TripMemberRemovalResult",
  id: string,
  tripId: string,
  userId: string,
  role?: TripRole | null,
  photosDeleted?: boolean | null,
  storageFreed?: number | null,
  deletedPhotoIds?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type CheckoutSessionResult = {
  __typename: "CheckoutSessionResult",
  sessionId: string,
  url: string,
};

export enum SubscriptionAction {
  CANCEL = "CANCEL",
  REACTIVATE = "REACTIVATE",
}


export type SubscriptionResult = {
  __typename: "SubscriptionResult",
  subscriptionId: string,
  status: string,
  message?: string | null,
};

export type AccountDeletionResult = {
  __typename: "AccountDeletionResult",
  userId: string,
  success: boolean,
  message?: string | null,
};

export type AppleReceiptValidationResult = {
  __typename: "AppleReceiptValidationResult",
  success: boolean,
  subscriptionId?: string | null,
  expiresDate?: number | null,
  productId?: string | null,
  tier?: StorageTier | null,
  message?: string | null,
};

export type GooglePurchaseValidationResult = {
  __typename: "GooglePurchaseValidationResult",
  success: boolean,
  subscriptionId?: string | null,
  expiresDate?: number | null,
  productId?: string | null,
  tier?: StorageTier | null,
  message?: string | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  storageTier?: ModelStorageTierInput | null,
  storageUsed?: ModelFloatInput | null,
  storageLimit?: ModelFloatInput | null,
  stripeCustomerId?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  subscriptionStatus?: ModelStringInput | null,
  subscriptionPeriodEnd?: ModelIntInput | null,
  appleSubscriptionId?: ModelStringInput | null,
  googleSubscriptionId?: ModelStringInput | null,
  appleReceiptData?: ModelStringInput | null,
  googlePurchaseToken?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelStorageTierConfigFilterInput = {
  id?: ModelIDInput | null,
  tier?: ModelStorageTierInput | null,
  name?: ModelStringInput | null,
  storageBytes?: ModelFloatInput | null,
  pricePerMonth?: ModelFloatInput | null,
  features?: ModelStringInput | null,
  version?: ModelFloatInput | null,
  isDefault?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  stripePriceId?: ModelStringInput | null,
  stripeProductId?: ModelStringInput | null,
  appleProductId?: ModelStringInput | null,
  googleProductId?: ModelStringInput | null,
  and?: Array< ModelStorageTierConfigFilterInput | null > | null,
  or?: Array< ModelStorageTierConfigFilterInput | null > | null,
  not?: ModelStorageTierConfigFilterInput | null,
};

export type ModelStorageTierConfigConnection = {
  __typename: "ModelStorageTierConfigConnection",
  items:  Array<StorageTierConfig | null >,
  nextToken?: string | null,
};

export type ModelSubscriptionEventFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  eventType?: ModelStringInput | null,
  platform?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  productId?: ModelStringInput | null,
  previousTier?: ModelStorageTierInput | null,
  newTier?: ModelStorageTierInput | null,
  metadata?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSubscriptionEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventFilterInput | null > | null,
  not?: ModelSubscriptionEventFilterInput | null,
};

export type ModelSubscriptionEventConnection = {
  __typename: "ModelSubscriptionEventConnection",
  items:  Array<SubscriptionEvent | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelFriendFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  friendId?: ModelIDInput | null,
  friendName?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  invited?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFriendFilterInput | null > | null,
  or?: Array< ModelFriendFilterInput | null > | null,
  not?: ModelFriendFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelPhotoFilterInput = {
  id?: ModelIDInput | null,
  tripId?: ModelIDInput | null,
  fileName?: ModelStringInput | null,
  s3Key?: ModelStringInput | null,
  uploadedBy?: ModelIDInput | null,
  status?: ModelPhotoStatusInput | null,
  fileSize?: ModelFloatInput | null,
  contentType?: ModelStringInput | null,
  thumbnailS3Key?: ModelStringInput | null,
  thumbnailWidth?: ModelIntInput | null,
  thumbnailHeight?: ModelIntInput | null,
  thumbnailSize?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelPhotoFilterInput | null > | null,
  or?: Array< ModelPhotoFilterInput | null > | null,
  not?: ModelPhotoFilterInput | null,
};

export type ModelTripInvitationFilterInput = {
  id?: ModelIDInput | null,
  tripId?: ModelIDInput | null,
  token?: ModelStringInput | null,
  role?: ModelTripRoleInput | null,
  createdBy?: ModelIDInput | null,
  expiresAt?: ModelIntInput | null,
  usedBy?: ModelIDInput | null,
  usedAt?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelTripInvitationFilterInput | null > | null,
  or?: Array< ModelTripInvitationFilterInput | null > | null,
  not?: ModelTripInvitationFilterInput | null,
};

export type ModelTripInvitationConnection = {
  __typename: "ModelTripInvitationConnection",
  items:  Array<TripInvitation | null >,
  nextToken?: string | null,
};

export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type PhotoUploadURL = {
  __typename: "PhotoUploadURL",
  uploadURL: string,
  photoId: string,
  fileSize: number,
};

export type S3PhotoAccess = {
  __typename: "S3PhotoAccess",
  bucket: string,
  key: string,
  region: string,
  identityId?: string | null,
  thumbnailKey?: string | null,
};

export type PhotoDownloadResponse = {
  __typename: "PhotoDownloadResponse",
  downloadUrls?:  Array<PhotoDownloadUrl | null > | null,
  zipUrl?: string | null,
};

export type PhotoDownloadUrl = {
  __typename: "PhotoDownloadUrl",
  id: string,
  url: string,
  fileName: string,
};

export type MemoriesResponse = {
  __typename: "MemoriesResponse",
  items?:  Array<MemoryItem | null > | null,
};

export type MemoryItem = {
  __typename: "MemoryItem",
  id: string,
  tripId: string,
  tripName: string,
  photoId: string,
  fileName?: string | null,
  uploadDate?: string | null,
  thumbnailS3Key?: string | null,
  uploaderName?: string | null,
  captionText?: string | null,
};

export type StripeConfig = {
  __typename: "StripeConfig",
  publishableKey: string,
  allowedCards?: Array< string | null > | null,
  billingEnabled?: boolean | null,
};

export type InAppProductsResult = {
  __typename: "InAppProductsResult",
  products:  Array<InAppProduct | null >,
};

export type InAppProduct = {
  __typename: "InAppProduct",
  id: string,
  tier: StorageTier,
  name: string,
  pricePerMonth: number,
  appleProductId?: string | null,
  googleProductId?: string | null,
  features: Array< string | null >,
};

export type ModelSubscriptionUserFilterInput = {
  name?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  storageTier?: ModelSubscriptionStringInput | null,
  storageUsed?: ModelSubscriptionFloatInput | null,
  storageLimit?: ModelSubscriptionFloatInput | null,
  stripeCustomerId?: ModelSubscriptionStringInput | null,
  subscriptionId?: ModelSubscriptionStringInput | null,
  subscriptionStatus?: ModelSubscriptionStringInput | null,
  subscriptionPeriodEnd?: ModelSubscriptionIntInput | null,
  appleSubscriptionId?: ModelSubscriptionStringInput | null,
  googleSubscriptionId?: ModelSubscriptionStringInput | null,
  appleReceiptData?: ModelSubscriptionStringInput | null,
  googlePurchaseToken?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
  id?: ModelStringInput | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionStorageTierConfigFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  tier?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  storageBytes?: ModelSubscriptionFloatInput | null,
  pricePerMonth?: ModelSubscriptionFloatInput | null,
  features?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionFloatInput | null,
  isDefault?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  stripePriceId?: ModelSubscriptionStringInput | null,
  stripeProductId?: ModelSubscriptionStringInput | null,
  appleProductId?: ModelSubscriptionStringInput | null,
  googleProductId?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionStorageTierConfigFilterInput | null > | null,
  or?: Array< ModelSubscriptionStorageTierConfigFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionSubscriptionEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  eventType?: ModelSubscriptionStringInput | null,
  platform?: ModelSubscriptionStringInput | null,
  subscriptionId?: ModelSubscriptionStringInput | null,
  productId?: ModelSubscriptionStringInput | null,
  previousTier?: ModelSubscriptionStringInput | null,
  newTier?: ModelSubscriptionStringInput | null,
  metadata?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSubscriptionEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionSubscriptionEventFilterInput | null > | null,
};

export type ModelSubscriptionFriendFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  friendId?: ModelSubscriptionIDInput | null,
  friendName?: ModelSubscriptionStringInput | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  invited?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFriendFilterInput | null > | null,
  or?: Array< ModelSubscriptionFriendFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionTripFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  tripName?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  storageUsed?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTripFilterInput | null > | null,
  or?: Array< ModelSubscriptionTripFilterInput | null > | null,
  createdBy?: ModelStringInput | null,
};

export type ModelSubscriptionTripMemberFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  tripId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  role?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTripMemberFilterInput | null > | null,
  or?: Array< ModelSubscriptionTripMemberFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionPhotoFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  tripId?: ModelSubscriptionIDInput | null,
  fileName?: ModelSubscriptionStringInput | null,
  s3Key?: ModelSubscriptionStringInput | null,
  uploadedBy?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  fileSize?: ModelSubscriptionFloatInput | null,
  contentType?: ModelSubscriptionStringInput | null,
  thumbnailS3Key?: ModelSubscriptionStringInput | null,
  thumbnailWidth?: ModelSubscriptionIntInput | null,
  thumbnailHeight?: ModelSubscriptionIntInput | null,
  thumbnailSize?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPhotoFilterInput | null > | null,
  or?: Array< ModelSubscriptionPhotoFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionTripInvitationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  tripId?: ModelSubscriptionIDInput | null,
  token?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionIDInput | null,
  expiresAt?: ModelSubscriptionIntInput | null,
  usedBy?: ModelSubscriptionIDInput | null,
  usedAt?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTripInvitationFilterInput | null > | null,
  or?: Array< ModelSubscriptionTripInvitationFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type FetchTripDetailsQueryVariables = {
  tripId: string,
};

export type FetchTripDetailsQuery = {
  getTripDetails?:  {
    __typename: "TripDetailsResponse",
    id: string,
    tripName: string,
    description?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    createdBy: string,
    creatorName?: string | null,
    storageUsed?: number | null,
    members?:  Array< {
      __typename: "MemberResponse",
      id: string,
      userId: string,
      role: string,
      userName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null > | null,
    photos?:  Array< {
      __typename: "PhotoDetailResponse",
      id: string,
      fileName: string,
      s3Key: string,
      uploadedBy: string,
      uploaderName?: string | null,
      status: string,
      fileSize: number,
      contentType?: string | null,
      thumbnailS3Key?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    userRole?: string | null,
  } | null,
};

export type CustomTripsByCreatedByQueryVariables = {
  createdBy: string,
};

export type CustomTripsByCreatedByQuery = {
  tripsByCreatedBy?:  {
    __typename: "ModelTripConnection",
    items:  Array< {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      createdAt: string,
      updatedAt: string,
      photos?:  {
        __typename: "ModelPhotoConnection",
        items:  Array< {
          __typename: "Photo",
          id: string,
          s3Key: string,
          fileName: string,
          status: PhotoStatus,
          createdAt?: string | null,
        } | null >,
      } | null,
    } | null >,
  } | null,
};

export type CustomListTripsQueryVariables = {
  filter?: ModelTripFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomListTripsQuery = {
  listTrips?:  {
    __typename: "ModelTripConnection",
    items:  Array< {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      createdAt: string,
      updatedAt: string,
      photos?:  {
        __typename: "ModelPhotoConnection",
        items:  Array< {
          __typename: "Photo",
          id: string,
          s3Key: string,
          fileName: string,
          uploadedBy: string,
          status: PhotoStatus,
          createdAt?: string | null,
        } | null >,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomTripMembersByUserIdQueryVariables = {
  userId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTripMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomTripMembersByUserIdQuery = {
  tripMembersByUserId?:  {
    __typename: "ModelTripMemberConnection",
    items:  Array< {
      __typename: "TripMember",
      role: TripRole,
      trip?:  {
        __typename: "Trip",
        id: string,
        tripName: string,
        description?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        createdBy: string,
        createdAt: string,
        updatedAt: string,
        photos?:  {
          __typename: "ModelPhotoConnection",
          items:  Array< {
            __typename: "Photo",
            id: string,
            s3Key: string,
            fileName: string,
            status: PhotoStatus,
            createdAt?: string | null,
          } | null >,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserWithStorageQueryVariables = {
  id: string,
};

export type GetUserWithStorageQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    name: string,
    email?: string | null,
    phoneNumber?: string | null,
    storageTier?: StorageTier | null,
    storageUsed?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetUserTripsWithStorageQueryVariables = {
  userId: string,
};

export type GetUserTripsWithStorageQuery = {
  tripMembersByUserId?:  {
    __typename: "ModelTripMemberConnection",
    items:  Array< {
      __typename: "TripMember",
      trip?:  {
        __typename: "Trip",
        id: string,
        tripName: string,
        description?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        storageUsed?: number | null,
        createdBy: string,
        photos?:  {
          __typename: "ModelPhotoConnection",
          items:  Array< {
            __typename: "Photo",
            id: string,
          } | null >,
        } | null,
        createdAt: string,
      } | null,
    } | null >,
  } | null,
};

export type ProcessInvitationCustomQueryVariables = {
  tripId: string,
  token?: string | null,
};

export type ProcessInvitationCustomQuery = {
  processInvitation?:  {
    __typename: "TripMembershipResponse",
    trip:  {
      __typename: "TripDetailsResponse",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      creatorName?: string | null,
      storageUsed?: number | null,
      members?:  Array< {
        __typename: "MemberResponse",
        id: string,
        userId: string,
        role: string,
        userName?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null > | null,
      photos?:  Array< {
        __typename: "PhotoDetailResponse",
        id: string,
        fileName: string,
        s3Key: string,
        uploadedBy: string,
        uploaderName?: string | null,
        status: string,
        fileSize: number,
        contentType?: string | null,
        thumbnailS3Key?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      userRole?: string | null,
    },
    membership?:  {
      __typename: "MemberResponse",
      id: string,
      userId: string,
      role: string,
      userName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    invitationProcessed: boolean,
    message?: string | null,
  } | null,
};

export type UpdatePhotoMutationVariables = {
  input: UpdatePhotoInput,
  condition?: ModelPhotoConditionInput | null,
};

export type UpdatePhotoMutation = {
  updatePhoto?:  {
    __typename: "Photo",
    id: string,
    tripId: string,
    fileName: string,
    s3Key: string,
    uploadedBy: string,
    status: PhotoStatus,
    fileSize: number,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contentType?: string | null,
    thumbnailS3Key?: string | null,
    thumbnailWidth?: number | null,
    thumbnailHeight?: number | null,
    thumbnailSize?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    name: string,
    email?: string | null,
    phoneNumber?: string | null,
    storageTier?: StorageTier | null,
    storageUsed?: number | null,
    storageLimit?: number | null,
    friends?:  {
      __typename: "ModelFriendConnection",
      nextToken?: string | null,
    } | null,
    trips?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscriptionId?: string | null,
    subscriptionStatus?: string | null,
    subscriptionPeriodEnd?: number | null,
    appleSubscriptionId?: string | null,
    googleSubscriptionId?: string | null,
    appleReceiptData?: string | null,
    googlePurchaseToken?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    name: string,
    email?: string | null,
    phoneNumber?: string | null,
    storageTier?: StorageTier | null,
    storageUsed?: number | null,
    storageLimit?: number | null,
    friends?:  {
      __typename: "ModelFriendConnection",
      nextToken?: string | null,
    } | null,
    trips?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscriptionId?: string | null,
    subscriptionStatus?: string | null,
    subscriptionPeriodEnd?: number | null,
    appleSubscriptionId?: string | null,
    googleSubscriptionId?: string | null,
    appleReceiptData?: string | null,
    googlePurchaseToken?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    name: string,
    email?: string | null,
    phoneNumber?: string | null,
    storageTier?: StorageTier | null,
    storageUsed?: number | null,
    storageLimit?: number | null,
    friends?:  {
      __typename: "ModelFriendConnection",
      nextToken?: string | null,
    } | null,
    trips?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscriptionId?: string | null,
    subscriptionStatus?: string | null,
    subscriptionPeriodEnd?: number | null,
    appleSubscriptionId?: string | null,
    googleSubscriptionId?: string | null,
    appleReceiptData?: string | null,
    googlePurchaseToken?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateStorageTierConfigMutationVariables = {
  input: CreateStorageTierConfigInput,
  condition?: ModelStorageTierConfigConditionInput | null,
};

export type CreateStorageTierConfigMutation = {
  createStorageTierConfig?:  {
    __typename: "StorageTierConfig",
    id: string,
    tier: StorageTier,
    name: string,
    storageBytes: number,
    pricePerMonth: number,
    features: Array< string | null >,
    version: number,
    isDefault?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    appleProductId?: string | null,
    googleProductId?: string | null,
  } | null,
};

export type UpdateStorageTierConfigMutationVariables = {
  input: UpdateStorageTierConfigInput,
  condition?: ModelStorageTierConfigConditionInput | null,
};

export type UpdateStorageTierConfigMutation = {
  updateStorageTierConfig?:  {
    __typename: "StorageTierConfig",
    id: string,
    tier: StorageTier,
    name: string,
    storageBytes: number,
    pricePerMonth: number,
    features: Array< string | null >,
    version: number,
    isDefault?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    appleProductId?: string | null,
    googleProductId?: string | null,
  } | null,
};

export type DeleteStorageTierConfigMutationVariables = {
  input: DeleteStorageTierConfigInput,
  condition?: ModelStorageTierConfigConditionInput | null,
};

export type DeleteStorageTierConfigMutation = {
  deleteStorageTierConfig?:  {
    __typename: "StorageTierConfig",
    id: string,
    tier: StorageTier,
    name: string,
    storageBytes: number,
    pricePerMonth: number,
    features: Array< string | null >,
    version: number,
    isDefault?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    appleProductId?: string | null,
    googleProductId?: string | null,
  } | null,
};

export type CreateSubscriptionEventMutationVariables = {
  input: CreateSubscriptionEventInput,
  condition?: ModelSubscriptionEventConditionInput | null,
};

export type CreateSubscriptionEventMutation = {
  createSubscriptionEvent?:  {
    __typename: "SubscriptionEvent",
    id: string,
    userId: string,
    eventType: string,
    platform: string,
    subscriptionId?: string | null,
    productId?: string | null,
    previousTier?: StorageTier | null,
    newTier?: StorageTier | null,
    metadata?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSubscriptionEventMutationVariables = {
  input: UpdateSubscriptionEventInput,
  condition?: ModelSubscriptionEventConditionInput | null,
};

export type UpdateSubscriptionEventMutation = {
  updateSubscriptionEvent?:  {
    __typename: "SubscriptionEvent",
    id: string,
    userId: string,
    eventType: string,
    platform: string,
    subscriptionId?: string | null,
    productId?: string | null,
    previousTier?: StorageTier | null,
    newTier?: StorageTier | null,
    metadata?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSubscriptionEventMutationVariables = {
  input: DeleteSubscriptionEventInput,
  condition?: ModelSubscriptionEventConditionInput | null,
};

export type DeleteSubscriptionEventMutation = {
  deleteSubscriptionEvent?:  {
    __typename: "SubscriptionEvent",
    id: string,
    userId: string,
    eventType: string,
    platform: string,
    subscriptionId?: string | null,
    productId?: string | null,
    previousTier?: StorageTier | null,
    newTier?: StorageTier | null,
    metadata?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFriendMutationVariables = {
  input: CreateFriendInput,
  condition?: ModelFriendConditionInput | null,
};

export type CreateFriendMutation = {
  createFriend?:  {
    __typename: "Friend",
    id: string,
    userId: string,
    friendId: string,
    friendName: string,
    phoneNumber?: string | null,
    invited?: boolean | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateFriendMutationVariables = {
  input: UpdateFriendInput,
  condition?: ModelFriendConditionInput | null,
};

export type UpdateFriendMutation = {
  updateFriend?:  {
    __typename: "Friend",
    id: string,
    userId: string,
    friendId: string,
    friendName: string,
    phoneNumber?: string | null,
    invited?: boolean | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteFriendMutationVariables = {
  input: DeleteFriendInput,
  condition?: ModelFriendConditionInput | null,
};

export type DeleteFriendMutation = {
  deleteFriend?:  {
    __typename: "Friend",
    id: string,
    userId: string,
    friendId: string,
    friendName: string,
    phoneNumber?: string | null,
    invited?: boolean | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateTripMutationVariables = {
  input: CreateTripInput,
  condition?: ModelTripConditionInput | null,
};

export type CreateTripMutation = {
  createTrip?:  {
    __typename: "Trip",
    id: string,
    tripName: string,
    description?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    createdBy: string,
    storageUsed?: number | null,
    members?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    photos?:  {
      __typename: "ModelPhotoConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTripMutationVariables = {
  input: UpdateTripInput,
  condition?: ModelTripConditionInput | null,
};

export type UpdateTripMutation = {
  updateTrip?:  {
    __typename: "Trip",
    id: string,
    tripName: string,
    description?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    createdBy: string,
    storageUsed?: number | null,
    members?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    photos?:  {
      __typename: "ModelPhotoConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTripMutationVariables = {
  input: DeleteTripInput,
  condition?: ModelTripConditionInput | null,
};

export type DeleteTripMutation = {
  deleteTrip?:  {
    __typename: "Trip",
    id: string,
    tripName: string,
    description?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    createdBy: string,
    storageUsed?: number | null,
    members?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    photos?:  {
      __typename: "ModelPhotoConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTripMemberMutationVariables = {
  input: CreateTripMemberInput,
  condition?: ModelTripMemberConditionInput | null,
};

export type CreateTripMemberMutation = {
  createTripMember?:  {
    __typename: "TripMember",
    id: string,
    tripId: string,
    userId: string,
    role: TripRole,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateTripMemberMutationVariables = {
  input: UpdateTripMemberInput,
  condition?: ModelTripMemberConditionInput | null,
};

export type UpdateTripMemberMutation = {
  updateTripMember?:  {
    __typename: "TripMember",
    id: string,
    tripId: string,
    userId: string,
    role: TripRole,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteTripMemberMutationVariables = {
  input: DeleteTripMemberInput,
  condition?: ModelTripMemberConditionInput | null,
};

export type DeleteTripMemberMutation = {
  deleteTripMember?:  {
    __typename: "TripMember",
    id: string,
    tripId: string,
    userId: string,
    role: TripRole,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreatePhotoMutationVariables = {
  input: CreatePhotoInput,
  condition?: ModelPhotoConditionInput | null,
};

export type CreatePhotoMutation = {
  createPhoto?:  {
    __typename: "Photo",
    id: string,
    tripId: string,
    fileName: string,
    s3Key: string,
    uploadedBy: string,
    status: PhotoStatus,
    fileSize: number,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contentType?: string | null,
    thumbnailS3Key?: string | null,
    thumbnailWidth?: number | null,
    thumbnailHeight?: number | null,
    thumbnailSize?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type DeletePhotoMutationVariables = {
  input: DeletePhotoInput,
  condition?: ModelPhotoConditionInput | null,
};

export type DeletePhotoMutation = {
  deletePhoto?:  {
    __typename: "Photo",
    id: string,
    tripId: string,
    fileName: string,
    s3Key: string,
    uploadedBy: string,
    status: PhotoStatus,
    fileSize: number,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contentType?: string | null,
    thumbnailS3Key?: string | null,
    thumbnailWidth?: number | null,
    thumbnailHeight?: number | null,
    thumbnailSize?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type CreateTripInvitationMutationVariables = {
  input: CreateTripInvitationInput,
  condition?: ModelTripInvitationConditionInput | null,
};

export type CreateTripInvitationMutation = {
  createTripInvitation?:  {
    __typename: "TripInvitation",
    id: string,
    tripId: string,
    token: string,
    role: TripRole,
    createdBy: string,
    expiresAt: number,
    usedBy?: string | null,
    usedAt?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type UpdateTripInvitationMutationVariables = {
  input: UpdateTripInvitationInput,
  condition?: ModelTripInvitationConditionInput | null,
};

export type UpdateTripInvitationMutation = {
  updateTripInvitation?:  {
    __typename: "TripInvitation",
    id: string,
    tripId: string,
    token: string,
    role: TripRole,
    createdBy: string,
    expiresAt: number,
    usedBy?: string | null,
    usedAt?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type DeleteTripInvitationMutationVariables = {
  input: DeleteTripInvitationInput,
  condition?: ModelTripInvitationConditionInput | null,
};

export type DeleteTripInvitationMutation = {
  deleteTripInvitation?:  {
    __typename: "TripInvitation",
    id: string,
    tripId: string,
    token: string,
    role: TripRole,
    createdBy: string,
    expiresAt: number,
    usedBy?: string | null,
    usedAt?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type DeletePhotoWithAuthMutationVariables = {
  photoId: string,
};

export type DeletePhotoWithAuthMutation = {
  deletePhotoWithAuth?:  {
    __typename: "Photo",
    id: string,
    tripId: string,
    fileName: string,
    s3Key: string,
    uploadedBy: string,
    status: PhotoStatus,
    fileSize: number,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contentType?: string | null,
    thumbnailS3Key?: string | null,
    thumbnailWidth?: number | null,
    thumbnailHeight?: number | null,
    thumbnailSize?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type InitStorageTiersMutationVariables = {
};

export type InitStorageTiersMutation = {
  initStorageTiers?:  Array< {
    __typename: "StorageTierConfig",
    id: string,
    tier: StorageTier,
    name: string,
    storageBytes: number,
    pricePerMonth: number,
    features: Array< string | null >,
    version: number,
    isDefault?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    appleProductId?: string | null,
    googleProductId?: string | null,
  } | null > | null,
};

export type DeleteTripWithAuthMutationVariables = {
  tripId: string,
};

export type DeleteTripWithAuthMutation = {
  deleteTripWithAuth?: boolean | null,
};

export type RemoveTripMemberWithAuthMutationVariables = {
  memberId: string,
  deletePhotos?: boolean | null,
};

export type RemoveTripMemberWithAuthMutation = {
  removeTripMemberWithAuth?:  {
    __typename: "TripMemberRemovalResult",
    id: string,
    tripId: string,
    userId: string,
    role?: TripRole | null,
    photosDeleted?: boolean | null,
    storageFreed?: number | null,
    deletedPhotoIds?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateCheckoutSessionMutationVariables = {
  tier: StorageTier,
  successUrl?: string | null,
  cancelUrl?: string | null,
};

export type CreateCheckoutSessionMutation = {
  createCheckoutSession?:  {
    __typename: "CheckoutSessionResult",
    sessionId: string,
    url: string,
  } | null,
};

export type ManageSubscriptionMutationVariables = {
  subscriptionId: string,
  action: SubscriptionAction,
};

export type ManageSubscriptionMutation = {
  manageSubscription?:  {
    __typename: "SubscriptionResult",
    subscriptionId: string,
    status: string,
    message?: string | null,
  } | null,
};

export type DeleteUserAccountMutationVariables = {
};

export type DeleteUserAccountMutation = {
  deleteUserAccount?:  {
    __typename: "AccountDeletionResult",
    userId: string,
    success: boolean,
    message?: string | null,
  } | null,
};

export type ValidateApplePurchaseMutationVariables = {
  receiptData: string,
  productId: string,
};

export type ValidateApplePurchaseMutation = {
  validateApplePurchase?:  {
    __typename: "AppleReceiptValidationResult",
    success: boolean,
    subscriptionId?: string | null,
    expiresDate?: number | null,
    productId?: string | null,
    tier?: StorageTier | null,
    message?: string | null,
  } | null,
};

export type ValidateGooglePurchaseMutationVariables = {
  purchaseToken: string,
  productId: string,
};

export type ValidateGooglePurchaseMutation = {
  validateGooglePurchase?:  {
    __typename: "GooglePurchaseValidationResult",
    success: boolean,
    subscriptionId?: string | null,
    expiresDate?: number | null,
    productId?: string | null,
    tier?: StorageTier | null,
    message?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    name: string,
    email?: string | null,
    phoneNumber?: string | null,
    storageTier?: StorageTier | null,
    storageUsed?: number | null,
    storageLimit?: number | null,
    friends?:  {
      __typename: "ModelFriendConnection",
      nextToken?: string | null,
    } | null,
    trips?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscriptionId?: string | null,
    subscriptionStatus?: string | null,
    subscriptionPeriodEnd?: number | null,
    appleSubscriptionId?: string | null,
    googleSubscriptionId?: string | null,
    appleReceiptData?: string | null,
    googlePurchaseToken?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserByStripeCustomerQueryVariables = {
  stripeCustomerId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserByStripeCustomerQuery = {
  userByStripeCustomer?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStorageTierConfigQueryVariables = {
  id: string,
};

export type GetStorageTierConfigQuery = {
  getStorageTierConfig?:  {
    __typename: "StorageTierConfig",
    id: string,
    tier: StorageTier,
    name: string,
    storageBytes: number,
    pricePerMonth: number,
    features: Array< string | null >,
    version: number,
    isDefault?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    appleProductId?: string | null,
    googleProductId?: string | null,
  } | null,
};

export type ListStorageTierConfigsQueryVariables = {
  filter?: ModelStorageTierConfigFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStorageTierConfigsQuery = {
  listStorageTierConfigs?:  {
    __typename: "ModelStorageTierConfigConnection",
    items:  Array< {
      __typename: "StorageTierConfig",
      id: string,
      tier: StorageTier,
      name: string,
      storageBytes: number,
      pricePerMonth: number,
      features: Array< string | null >,
      version: number,
      isDefault?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      appleProductId?: string | null,
      googleProductId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type StorageTierConfigByTierQueryVariables = {
  tier: StorageTier,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStorageTierConfigFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type StorageTierConfigByTierQuery = {
  storageTierConfigByTier?:  {
    __typename: "ModelStorageTierConfigConnection",
    items:  Array< {
      __typename: "StorageTierConfig",
      id: string,
      tier: StorageTier,
      name: string,
      storageBytes: number,
      pricePerMonth: number,
      features: Array< string | null >,
      version: number,
      isDefault?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      stripePriceId?: string | null,
      stripeProductId?: string | null,
      appleProductId?: string | null,
      googleProductId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSubscriptionEventQueryVariables = {
  id: string,
};

export type GetSubscriptionEventQuery = {
  getSubscriptionEvent?:  {
    __typename: "SubscriptionEvent",
    id: string,
    userId: string,
    eventType: string,
    platform: string,
    subscriptionId?: string | null,
    productId?: string | null,
    previousTier?: StorageTier | null,
    newTier?: StorageTier | null,
    metadata?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSubscriptionEventsQueryVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubscriptionEventsQuery = {
  listSubscriptionEvents?:  {
    __typename: "ModelSubscriptionEventConnection",
    items:  Array< {
      __typename: "SubscriptionEvent",
      id: string,
      userId: string,
      eventType: string,
      platform: string,
      subscriptionId?: string | null,
      productId?: string | null,
      previousTier?: StorageTier | null,
      newTier?: StorageTier | null,
      metadata?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SubscriptionEventsByUserIdAndCreatedAtQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSubscriptionEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SubscriptionEventsByUserIdAndCreatedAtQuery = {
  subscriptionEventsByUserIdAndCreatedAt?:  {
    __typename: "ModelSubscriptionEventConnection",
    items:  Array< {
      __typename: "SubscriptionEvent",
      id: string,
      userId: string,
      eventType: string,
      platform: string,
      subscriptionId?: string | null,
      productId?: string | null,
      previousTier?: StorageTier | null,
      newTier?: StorageTier | null,
      metadata?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFriendQueryVariables = {
  id: string,
};

export type GetFriendQuery = {
  getFriend?:  {
    __typename: "Friend",
    id: string,
    userId: string,
    friendId: string,
    friendName: string,
    phoneNumber?: string | null,
    invited?: boolean | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListFriendsQueryVariables = {
  filter?: ModelFriendFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFriendsQuery = {
  listFriends?:  {
    __typename: "ModelFriendConnection",
    items:  Array< {
      __typename: "Friend",
      id: string,
      userId: string,
      friendId: string,
      friendName: string,
      phoneNumber?: string | null,
      invited?: boolean | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FriendsByUserIdQueryVariables = {
  userId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFriendFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FriendsByUserIdQuery = {
  friendsByUserId?:  {
    __typename: "ModelFriendConnection",
    items:  Array< {
      __typename: "Friend",
      id: string,
      userId: string,
      friendId: string,
      friendName: string,
      phoneNumber?: string | null,
      invited?: boolean | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTripQueryVariables = {
  id: string,
};

export type GetTripQuery = {
  getTrip?:  {
    __typename: "Trip",
    id: string,
    tripName: string,
    description?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    createdBy: string,
    storageUsed?: number | null,
    members?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    photos?:  {
      __typename: "ModelPhotoConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTripsQueryVariables = {
  filter?: ModelTripFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTripsQuery = {
  listTrips?:  {
    __typename: "ModelTripConnection",
    items:  Array< {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TripsByCreatedByQueryVariables = {
  createdBy: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTripFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TripsByCreatedByQuery = {
  tripsByCreatedBy?:  {
    __typename: "ModelTripConnection",
    items:  Array< {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTripMemberQueryVariables = {
  id: string,
};

export type GetTripMemberQuery = {
  getTripMember?:  {
    __typename: "TripMember",
    id: string,
    tripId: string,
    userId: string,
    role: TripRole,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListTripMembersQueryVariables = {
  filter?: ModelTripMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTripMembersQuery = {
  listTripMembers?:  {
    __typename: "ModelTripMemberConnection",
    items:  Array< {
      __typename: "TripMember",
      id: string,
      tripId: string,
      userId: string,
      role: TripRole,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TripMembersByTripIdQueryVariables = {
  tripId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTripMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TripMembersByTripIdQuery = {
  tripMembersByTripId?:  {
    __typename: "ModelTripMemberConnection",
    items:  Array< {
      __typename: "TripMember",
      id: string,
      tripId: string,
      userId: string,
      role: TripRole,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TripMembersByUserIdQueryVariables = {
  userId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTripMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TripMembersByUserIdQuery = {
  tripMembersByUserId?:  {
    __typename: "ModelTripMemberConnection",
    items:  Array< {
      __typename: "TripMember",
      id: string,
      tripId: string,
      userId: string,
      role: TripRole,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPhotoQueryVariables = {
  id: string,
};

export type GetPhotoQuery = {
  getPhoto?:  {
    __typename: "Photo",
    id: string,
    tripId: string,
    fileName: string,
    s3Key: string,
    uploadedBy: string,
    status: PhotoStatus,
    fileSize: number,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contentType?: string | null,
    thumbnailS3Key?: string | null,
    thumbnailWidth?: number | null,
    thumbnailHeight?: number | null,
    thumbnailSize?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type ListPhotosQueryVariables = {
  filter?: ModelPhotoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPhotosQuery = {
  listPhotos?:  {
    __typename: "ModelPhotoConnection",
    items:  Array< {
      __typename: "Photo",
      id: string,
      tripId: string,
      fileName: string,
      s3Key: string,
      uploadedBy: string,
      status: PhotoStatus,
      fileSize: number,
      contentType?: string | null,
      thumbnailS3Key?: string | null,
      thumbnailWidth?: number | null,
      thumbnailHeight?: number | null,
      thumbnailSize?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PhotosByTripIdQueryVariables = {
  tripId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPhotoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PhotosByTripIdQuery = {
  photosByTripId?:  {
    __typename: "ModelPhotoConnection",
    items:  Array< {
      __typename: "Photo",
      id: string,
      tripId: string,
      fileName: string,
      s3Key: string,
      uploadedBy: string,
      status: PhotoStatus,
      fileSize: number,
      contentType?: string | null,
      thumbnailS3Key?: string | null,
      thumbnailWidth?: number | null,
      thumbnailHeight?: number | null,
      thumbnailSize?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTripInvitationQueryVariables = {
  id: string,
};

export type GetTripInvitationQuery = {
  getTripInvitation?:  {
    __typename: "TripInvitation",
    id: string,
    tripId: string,
    token: string,
    role: TripRole,
    createdBy: string,
    expiresAt: number,
    usedBy?: string | null,
    usedAt?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type ListTripInvitationsQueryVariables = {
  filter?: ModelTripInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTripInvitationsQuery = {
  listTripInvitations?:  {
    __typename: "ModelTripInvitationConnection",
    items:  Array< {
      __typename: "TripInvitation",
      id: string,
      tripId: string,
      token: string,
      role: TripRole,
      createdBy: string,
      expiresAt: number,
      usedBy?: string | null,
      usedAt?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TripInvitationsByTripIdAndExpiresAtQueryVariables = {
  tripId: string,
  expiresAt?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTripInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TripInvitationsByTripIdAndExpiresAtQuery = {
  tripInvitationsByTripIdAndExpiresAt?:  {
    __typename: "ModelTripInvitationConnection",
    items:  Array< {
      __typename: "TripInvitation",
      id: string,
      tripId: string,
      token: string,
      role: TripRole,
      createdBy: string,
      expiresAt: number,
      usedBy?: string | null,
      usedAt?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPhotoUploadURLQueryVariables = {
  tripId: string,
  fileName: string,
  contentType: string,
  identityId: string,
  fileSize: number,
};

export type GetPhotoUploadURLQuery = {
  getPhotoUploadURL?:  {
    __typename: "PhotoUploadURL",
    uploadURL: string,
    photoId: string,
    fileSize: number,
  } | null,
};

export type GetPhotoAccessQueryVariables = {
  photoId: string,
  thumbnailOnly?: boolean | null,
};

export type GetPhotoAccessQuery = {
  getPhotoAccess?:  {
    __typename: "S3PhotoAccess",
    bucket: string,
    key: string,
    region: string,
    identityId?: string | null,
    thumbnailKey?: string | null,
  } | null,
};

export type GeneratePhotoDownloadQueryVariables = {
  photoIds: Array< string >,
  tripId: string,
  zipDownload?: boolean | null,
};

export type GeneratePhotoDownloadQuery = {
  generatePhotoDownload?:  {
    __typename: "PhotoDownloadResponse",
    downloadUrls?:  Array< {
      __typename: "PhotoDownloadUrl",
      id: string,
      url: string,
      fileName: string,
    } | null > | null,
    zipUrl?: string | null,
  } | null,
};

export type GetTripDetailsQueryVariables = {
  tripId: string,
};

export type GetTripDetailsQuery = {
  getTripDetails?:  {
    __typename: "TripDetailsResponse",
    id: string,
    tripName: string,
    description?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    createdBy: string,
    creatorName?: string | null,
    storageUsed?: number | null,
    members?:  Array< {
      __typename: "MemberResponse",
      id: string,
      userId: string,
      role: string,
      userName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null > | null,
    photos?:  Array< {
      __typename: "PhotoDetailResponse",
      id: string,
      fileName: string,
      s3Key: string,
      uploadedBy: string,
      uploaderName?: string | null,
      status: string,
      fileSize: number,
      contentType?: string | null,
      thumbnailS3Key?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    userRole?: string | null,
  } | null,
};

export type ProcessInvitationQueryVariables = {
  tripId: string,
  token?: string | null,
};

export type ProcessInvitationQuery = {
  processInvitation?:  {
    __typename: "TripMembershipResponse",
    trip:  {
      __typename: "TripDetailsResponse",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      creatorName?: string | null,
      storageUsed?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      userRole?: string | null,
    },
    membership?:  {
      __typename: "MemberResponse",
      id: string,
      userId: string,
      role: string,
      userName?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    invitationProcessed: boolean,
    message?: string | null,
  } | null,
};

export type GetUserMemoriesQueryVariables = {
  limit?: number | null,
};

export type GetUserMemoriesQuery = {
  getUserMemories?:  {
    __typename: "MemoriesResponse",
    items?:  Array< {
      __typename: "MemoryItem",
      id: string,
      tripId: string,
      tripName: string,
      photoId: string,
      fileName?: string | null,
      uploadDate?: string | null,
      thumbnailS3Key?: string | null,
      uploaderName?: string | null,
      captionText?: string | null,
    } | null > | null,
  } | null,
};

export type GetStripeConfigQueryVariables = {
};

export type GetStripeConfigQuery = {
  getStripeConfig?:  {
    __typename: "StripeConfig",
    publishableKey: string,
    allowedCards?: Array< string | null > | null,
    billingEnabled?: boolean | null,
  } | null,
};

export type GetInAppProductsQueryVariables = {
};

export type GetInAppProductsQuery = {
  getInAppProducts?:  {
    __typename: "InAppProductsResult",
    products:  Array< {
      __typename: "InAppProduct",
      id: string,
      tier: StorageTier,
      name: string,
      pricePerMonth: number,
      appleProductId?: string | null,
      googleProductId?: string | null,
      features: Array< string | null >,
    } | null >,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    name: string,
    email?: string | null,
    phoneNumber?: string | null,
    storageTier?: StorageTier | null,
    storageUsed?: number | null,
    storageLimit?: number | null,
    friends?:  {
      __typename: "ModelFriendConnection",
      nextToken?: string | null,
    } | null,
    trips?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscriptionId?: string | null,
    subscriptionStatus?: string | null,
    subscriptionPeriodEnd?: number | null,
    appleSubscriptionId?: string | null,
    googleSubscriptionId?: string | null,
    appleReceiptData?: string | null,
    googlePurchaseToken?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    name: string,
    email?: string | null,
    phoneNumber?: string | null,
    storageTier?: StorageTier | null,
    storageUsed?: number | null,
    storageLimit?: number | null,
    friends?:  {
      __typename: "ModelFriendConnection",
      nextToken?: string | null,
    } | null,
    trips?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscriptionId?: string | null,
    subscriptionStatus?: string | null,
    subscriptionPeriodEnd?: number | null,
    appleSubscriptionId?: string | null,
    googleSubscriptionId?: string | null,
    appleReceiptData?: string | null,
    googlePurchaseToken?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  id?: string | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    name: string,
    email?: string | null,
    phoneNumber?: string | null,
    storageTier?: StorageTier | null,
    storageUsed?: number | null,
    storageLimit?: number | null,
    friends?:  {
      __typename: "ModelFriendConnection",
      nextToken?: string | null,
    } | null,
    trips?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscriptionId?: string | null,
    subscriptionStatus?: string | null,
    subscriptionPeriodEnd?: number | null,
    appleSubscriptionId?: string | null,
    googleSubscriptionId?: string | null,
    appleReceiptData?: string | null,
    googlePurchaseToken?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateStorageTierConfigSubscriptionVariables = {
  filter?: ModelSubscriptionStorageTierConfigFilterInput | null,
};

export type OnCreateStorageTierConfigSubscription = {
  onCreateStorageTierConfig?:  {
    __typename: "StorageTierConfig",
    id: string,
    tier: StorageTier,
    name: string,
    storageBytes: number,
    pricePerMonth: number,
    features: Array< string | null >,
    version: number,
    isDefault?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    appleProductId?: string | null,
    googleProductId?: string | null,
  } | null,
};

export type OnUpdateStorageTierConfigSubscriptionVariables = {
  filter?: ModelSubscriptionStorageTierConfigFilterInput | null,
};

export type OnUpdateStorageTierConfigSubscription = {
  onUpdateStorageTierConfig?:  {
    __typename: "StorageTierConfig",
    id: string,
    tier: StorageTier,
    name: string,
    storageBytes: number,
    pricePerMonth: number,
    features: Array< string | null >,
    version: number,
    isDefault?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    appleProductId?: string | null,
    googleProductId?: string | null,
  } | null,
};

export type OnDeleteStorageTierConfigSubscriptionVariables = {
  filter?: ModelSubscriptionStorageTierConfigFilterInput | null,
};

export type OnDeleteStorageTierConfigSubscription = {
  onDeleteStorageTierConfig?:  {
    __typename: "StorageTierConfig",
    id: string,
    tier: StorageTier,
    name: string,
    storageBytes: number,
    pricePerMonth: number,
    features: Array< string | null >,
    version: number,
    isDefault?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    stripePriceId?: string | null,
    stripeProductId?: string | null,
    appleProductId?: string | null,
    googleProductId?: string | null,
  } | null,
};

export type OnCreateSubscriptionEventSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionEventFilterInput | null,
};

export type OnCreateSubscriptionEventSubscription = {
  onCreateSubscriptionEvent?:  {
    __typename: "SubscriptionEvent",
    id: string,
    userId: string,
    eventType: string,
    platform: string,
    subscriptionId?: string | null,
    productId?: string | null,
    previousTier?: StorageTier | null,
    newTier?: StorageTier | null,
    metadata?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSubscriptionEventSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionEventFilterInput | null,
};

export type OnUpdateSubscriptionEventSubscription = {
  onUpdateSubscriptionEvent?:  {
    __typename: "SubscriptionEvent",
    id: string,
    userId: string,
    eventType: string,
    platform: string,
    subscriptionId?: string | null,
    productId?: string | null,
    previousTier?: StorageTier | null,
    newTier?: StorageTier | null,
    metadata?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSubscriptionEventSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionEventFilterInput | null,
};

export type OnDeleteSubscriptionEventSubscription = {
  onDeleteSubscriptionEvent?:  {
    __typename: "SubscriptionEvent",
    id: string,
    userId: string,
    eventType: string,
    platform: string,
    subscriptionId?: string | null,
    productId?: string | null,
    previousTier?: StorageTier | null,
    newTier?: StorageTier | null,
    metadata?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFriendSubscriptionVariables = {
  filter?: ModelSubscriptionFriendFilterInput | null,
  owner?: string | null,
};

export type OnCreateFriendSubscription = {
  onCreateFriend?:  {
    __typename: "Friend",
    id: string,
    userId: string,
    friendId: string,
    friendName: string,
    phoneNumber?: string | null,
    invited?: boolean | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateFriendSubscriptionVariables = {
  filter?: ModelSubscriptionFriendFilterInput | null,
  owner?: string | null,
};

export type OnUpdateFriendSubscription = {
  onUpdateFriend?:  {
    __typename: "Friend",
    id: string,
    userId: string,
    friendId: string,
    friendName: string,
    phoneNumber?: string | null,
    invited?: boolean | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteFriendSubscriptionVariables = {
  filter?: ModelSubscriptionFriendFilterInput | null,
  owner?: string | null,
};

export type OnDeleteFriendSubscription = {
  onDeleteFriend?:  {
    __typename: "Friend",
    id: string,
    userId: string,
    friendId: string,
    friendName: string,
    phoneNumber?: string | null,
    invited?: boolean | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateTripSubscriptionVariables = {
  filter?: ModelSubscriptionTripFilterInput | null,
  createdBy?: string | null,
};

export type OnCreateTripSubscription = {
  onCreateTrip?:  {
    __typename: "Trip",
    id: string,
    tripName: string,
    description?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    createdBy: string,
    storageUsed?: number | null,
    members?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    photos?:  {
      __typename: "ModelPhotoConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTripSubscriptionVariables = {
  filter?: ModelSubscriptionTripFilterInput | null,
  createdBy?: string | null,
};

export type OnUpdateTripSubscription = {
  onUpdateTrip?:  {
    __typename: "Trip",
    id: string,
    tripName: string,
    description?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    createdBy: string,
    storageUsed?: number | null,
    members?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    photos?:  {
      __typename: "ModelPhotoConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTripSubscriptionVariables = {
  filter?: ModelSubscriptionTripFilterInput | null,
  createdBy?: string | null,
};

export type OnDeleteTripSubscription = {
  onDeleteTrip?:  {
    __typename: "Trip",
    id: string,
    tripName: string,
    description?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    createdBy: string,
    storageUsed?: number | null,
    members?:  {
      __typename: "ModelTripMemberConnection",
      nextToken?: string | null,
    } | null,
    photos?:  {
      __typename: "ModelPhotoConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTripMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTripMemberFilterInput | null,
  owner?: string | null,
};

export type OnCreateTripMemberSubscription = {
  onCreateTripMember?:  {
    __typename: "TripMember",
    id: string,
    tripId: string,
    userId: string,
    role: TripRole,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateTripMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTripMemberFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTripMemberSubscription = {
  onUpdateTripMember?:  {
    __typename: "TripMember",
    id: string,
    tripId: string,
    userId: string,
    role: TripRole,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteTripMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTripMemberFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTripMemberSubscription = {
  onDeleteTripMember?:  {
    __typename: "TripMember",
    id: string,
    tripId: string,
    userId: string,
    role: TripRole,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      name: string,
      email?: string | null,
      phoneNumber?: string | null,
      storageTier?: StorageTier | null,
      storageUsed?: number | null,
      storageLimit?: number | null,
      stripeCustomerId?: string | null,
      subscriptionId?: string | null,
      subscriptionStatus?: string | null,
      subscriptionPeriodEnd?: number | null,
      appleSubscriptionId?: string | null,
      googleSubscriptionId?: string | null,
      appleReceiptData?: string | null,
      googlePurchaseToken?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreatePhotoSubscriptionVariables = {
  filter?: ModelSubscriptionPhotoFilterInput | null,
};

export type OnCreatePhotoSubscription = {
  onCreatePhoto?:  {
    __typename: "Photo",
    id: string,
    tripId: string,
    fileName: string,
    s3Key: string,
    uploadedBy: string,
    status: PhotoStatus,
    fileSize: number,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contentType?: string | null,
    thumbnailS3Key?: string | null,
    thumbnailWidth?: number | null,
    thumbnailHeight?: number | null,
    thumbnailSize?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdatePhotoSubscriptionVariables = {
  filter?: ModelSubscriptionPhotoFilterInput | null,
};

export type OnUpdatePhotoSubscription = {
  onUpdatePhoto?:  {
    __typename: "Photo",
    id: string,
    tripId: string,
    fileName: string,
    s3Key: string,
    uploadedBy: string,
    status: PhotoStatus,
    fileSize: number,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contentType?: string | null,
    thumbnailS3Key?: string | null,
    thumbnailWidth?: number | null,
    thumbnailHeight?: number | null,
    thumbnailSize?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeletePhotoSubscriptionVariables = {
  filter?: ModelSubscriptionPhotoFilterInput | null,
};

export type OnDeletePhotoSubscription = {
  onDeletePhoto?:  {
    __typename: "Photo",
    id: string,
    tripId: string,
    fileName: string,
    s3Key: string,
    uploadedBy: string,
    status: PhotoStatus,
    fileSize: number,
    trip?:  {
      __typename: "Trip",
      id: string,
      tripName: string,
      description?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      createdBy: string,
      storageUsed?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contentType?: string | null,
    thumbnailS3Key?: string | null,
    thumbnailWidth?: number | null,
    thumbnailHeight?: number | null,
    thumbnailSize?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type OnCreateTripInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionTripInvitationFilterInput | null,
  owner?: string | null,
};

export type OnCreateTripInvitationSubscription = {
  onCreateTripInvitation?:  {
    __typename: "TripInvitation",
    id: string,
    tripId: string,
    token: string,
    role: TripRole,
    createdBy: string,
    expiresAt: number,
    usedBy?: string | null,
    usedAt?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdateTripInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionTripInvitationFilterInput | null,
  owner?: string | null,
};

export type OnUpdateTripInvitationSubscription = {
  onUpdateTripInvitation?:  {
    __typename: "TripInvitation",
    id: string,
    tripId: string,
    token: string,
    role: TripRole,
    createdBy: string,
    expiresAt: number,
    usedBy?: string | null,
    usedAt?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeleteTripInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionTripInvitationFilterInput | null,
  owner?: string | null,
};

export type OnDeleteTripInvitationSubscription = {
  onDeleteTripInvitation?:  {
    __typename: "TripInvitation",
    id: string,
    tripId: string,
    token: string,
    role: TripRole,
    createdBy: string,
    expiresAt: number,
    usedBy?: string | null,
    usedAt?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
  } | null,
};
